import ScrollReveal from './ScrollReveal';

const bonuses = [
  {
    title: 'Ebook WhatsApp Closing Mastery',
    desc: 'Domina el arte de cerrar ventas por WhatsApp con estrategias comprobadas. Aumenta tu tasa de conversión en chats.',
    value: '9.9 USD',
    tag: 'BONUS 1',
    image: 'https://readdy.ai/api/search-image?query=Premium%20ebook%20cover%20mockup%20titled%20WhatsApp%20Closing%20Mastery%20with%20elegant%20red%20and%20gold%20color%20scheme%20on%20clean%20white%20background%2C%20modern%20minimalist%20book%20cover%20design%2C%203D%20book%20mockup%20with%20soft%20shadows%2C%20professional%20product%20photography%2C%20high%20quality%20studio%20render%2C%20luxury%20aesthetic&width=500&height=600&seq=sell-more-bonus-ebook&orientation=portrait',
  },
];

export default function Bonuses() {
  return (
    <section className="py-20 md:py-28 bg-[#FFFFFF]">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-14">
            <span className="inline-block text-xs font-semibold tracking-wider uppercase text-[#C8A24A] mb-3">
              Regalos
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-[#111111]">
              Bonos Exclusivos
            </h2>
            <p className="text-[#666666] mt-3 max-w-[500px] mx-auto text-sm">
              Al comprar el taller recibes este bonus completamente gratis.
            </p>
          </div>
        </ScrollReveal>

        <div className="max-w-[520px] mx-auto">
          {bonuses.map((bonus, idx) => (
            <ScrollReveal key={bonus.tag} delay={idx * 150}>
              <div className="group bg-[#F7F8FA] rounded-2xl border border-gray-100 overflow-hidden hover:border-[#C8A24A]/20 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(0,0,0,0.06)]">
                {/* Image */}
                <div className="relative h-[340px] bg-white">
                  <img
                    src={bonus.image}
                    alt={bonus.title}
                    title={bonus.title}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#E53935] text-white text-[10px] font-bold tracking-wider uppercase">
                    {bonus.tag}
                  </div>
                  <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-white/90 backdrop-blur-sm border border-gray-100 text-[#111111] text-xs font-bold">
                    <span className="text-[#C8A24A] mr-0.5">✦</span> GRATIS
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 md:p-7">
                  <h3 className="font-heading text-xl font-semibold text-[#111111] mb-2">
                    {bonus.title}
                  </h3>
                  <p className="text-sm text-[#666666] leading-relaxed mb-4">
                    {bonus.desc}
                  </p>
                  <div className="flex items-center gap-2 pt-4 border-t border-gray-200">
                    <span className="text-xs text-[#888888]">Valor:</span>
                    <span className="text-sm font-bold text-[#111111]">{bonus.value}</span>
                    <span className="ml-auto text-xs text-[#E53935] font-semibold line-through">{bonus.value}</span>
                  </div>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}